import styled from 'styled-components';

const PROGRESS_BAR_TYPE_MAP = {
    INFO: {
        color: '#3179AD',
    },
    SUCCESS: {
        color: '#41A667',
    },
    WARNING: {
        color: '#FFB300',
    },
    ERROR: {
        color: '#E82E41',
    },
};

export const ProgressBarContainer = styled.div`
    height: 100%;
    width: 100%;
    border-radius: ${({ borderRadius }) => borderRadius};
    border: 1px solid ${({ type }) => PROGRESS_BAR_TYPE_MAP[type].color};
`;

export const ProgressBarFiller = styled.div`
    background: ${({ type }) => PROGRESS_BAR_TYPE_MAP[type].color};
    height: 100%;
    width: ${({ percentage }) => percentage}%;
    border-radius: inherit;
    transition: width .2s ease-out;
`;
